import React from 'react';

const PredictionFormatter = ({ predictionData }) => {
  const cleanGeminiResponse = (rawText) => {
    return rawText
      .replace(/^\s*```json\s*/i, '')
      .replace(/^\s*```/, '')
      .replace(/\s*```$/, '')
      .trim();
  };

  if (!predictionData) return <p style={{ color: '#ccc' }}>No prediction data available.</p>;

  const cleaned = typeof predictionData === 'string'
    ? JSON.parse(cleanGeminiResponse(predictionData))
    : predictionData;

  const predictions = cleaned.predictions || [];

  return (
    <div style={{ maxWidth: '800px', margin: '2rem auto', padding: '2rem', backgroundColor: '#0f172a', color: '#f1f5f9', borderRadius: '1rem', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.5)', textAlign:'center' }}>
      <h2 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#38bdf8', marginBottom: '1.5rem' }}>🔮 Predictive AI Insights</h2>
      <p style={{ color: '#cbd5e1', marginBottom: '1rem' }}>
        Based on your current performance trends, here are estimated timelines and recommendations:
      </p>
      <div style={{ display: 'grid', gap: '1.5rem' }}>
        {predictions.map((item, i) => (
          <div key={i} style={{ border: '1px solid #334155', borderRadius: '0.5rem', backgroundColor: '#1e293b', padding: '1rem' }}>
            <h3 style={{ color: '#facc15', marginBottom: '0.5rem' }}>{item.activity}</h3>
            <p><strong>Estimated Time to Goal:</strong> {item.estimatedTimeToGoal}</p>
            <p><strong>Likelihood of Success:</strong> {item.likelihoodOfSuccess}</p>
            <p><strong>Recommendation:</strong> {item.recommendation}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PredictionFormatter;
